import { ISyncContext } from './sync-context';

export interface ISyncElement {
  name: string;
  execute(context: ISyncContext): Promise<SyncElementResult>;
}

export interface SyncElementResult {
  jobDone: boolean; // for easier debugging we flag elements that did not finish as expected
  contextId: string;
  [key: string]: unknown; // allow extra properties
}
